export default {
  feedbackReports: {
    tab: 'Feedback',
    title: 'Course feedback',
    subtitle: 'View submitted feedback for the selected courses and dates.',
    allCourses: 'All courses',
    from: 'From (UTC)',
    to: 'To (UTC)',
    apply: 'Apply filters',
    dateError: 'The start date must not be after the end date.',
    exportHint: 'Exports all filtered responses, one row per question. Up to 10,000 responses per export.',
    exportLimit: 'More than 10,000 responses match these filters. Select a course or a shorter date range to export.',
    empty: 'No feedback found',
    emptyHint: 'No feedback has been submitted for these filters yet.',
    responseCount: 'Responses',
    average: 'Average helpfulness',
    ratedCount: 'Based on {count} ratings',
    version: 'Questionnaire version {version} · {count} responses',
    answered: '{count} of {total} answered',
    multipleHint: 'Multiple selections allowed. Percentages use the number of people who answered this question.',
    responses: 'Individual responses',
    submitted: 'Submitted (UTC)',
    helpfulness: 'Helpfulness',
    answers: 'Answers',
    view: 'View answers',
    previous: 'Previous',
    next: 'Next',
    page: 'Page {page} of {total}',
    responseFrom: 'Feedback from {name}',
    responseVersion: 'Course version {course} · Questionnaire version {questionnaire}',
    unanswered: 'Not answered',
    close: 'Close answers',
  },
  courseFeedback: {
    tab: 'Course feedback',
    navigationLocked: 'Please complete and send the feedback form first.',
    submitCertificate: 'Send feedback and view certificate',
    submitCourses: 'Send feedback and return to courses',
    submitJourney: 'Send feedback and continue journey',
    backToJourney: 'Back to journey',
    readOnly: 'These are the answers you submitted for this course.',
    notAnswered: 'Not answered',
    eyebrow: 'Course complete',
    completeTitle: 'Well done! You finished the course.',
    title: 'How was your course?',
    intro: 'Your feedback helps us improve future courses. It only takes a few clicks.',
    required: 'Required',
    optional: 'Optional',
    multiple: 'You can select more than one.',
    thanks: 'Thank you for your feedback!',
    saved: 'Your answers have been saved for this course.',
    loading: 'Loading feedback…',
    loadError: 'We could not load the feedback form. Your course is complete. Please try again.',
    retry: 'Try again',
    saveError:
      'Your feedback could not be saved. Your selections are still here. Please try sending again.',
    submit: 'Send feedback',
    completionSaved: 'Your course completion is already saved.',
    certificate: 'View certificate',
    backToCourses: 'Back to courses',
  },
  common: {
    appName: 'Reybex Academy',
    save: 'Save',
    saving: 'Saving…',
    saved: 'Saved',
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    remove: 'Remove',
    edit: 'Edit',
    create: 'Create',
    add: 'Add',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    search: 'Search',
    searchPlaceholder: 'Search…',
    filter: 'Filter',
    clear: 'Clear',
    clearFilters: 'Clear filters',
    all: 'All',
    none: 'None',
    yes: 'Yes',
    no: 'No',
    optional: 'Optional',
    required: 'Required',
    loading: 'Loading…',
    retry: 'Try again',
    confirm: 'Confirm',
    actions: 'Actions',
    status: 'Status',
    title: 'Title',
    description: 'Description',
    duration: 'Duration',
    points: 'points',
    pointsLabel: 'Points',
    progress: 'Progress',
    minutes: '{count} min',
    hours: '{count} h',
    of: 'of',
    showing: 'Showing {from}–{to} of {total}',
    page: 'Page {page}',
    unknown: 'Unknown',
    never: 'Never',
    today: 'Today',
    dueOn: 'Due {date}',
    overdue: 'Overdue',
    notSet: 'Not set',
    copy: 'Copy',
    copied: 'Copied',
    copyLink: 'Copy public link',
    linkCopied: 'Link copied.',
    download: 'Download',
    preview: 'Preview',
    publish: 'Publish',
    unpublish: 'Unpublish',
    archive: 'Archive',
    restore: 'Restore',
    signOut: 'Sign out',
    profile: 'Profile',
    language: 'Language',
    theme: 'Theme',
    learner: 'Learner',
    instructor: 'Instructor',
    admin: 'Admin',
  },

  nav: {
    dashboard: 'Dashboard',
    courses: 'Courses',
    journeys: 'Journeys',
    certificates: 'Certificates',
    profile: 'Profile',
    adminArea: 'Administration',
    adminDashboard: 'Courses',
    adminCourses: 'Courses',
    adminJourneys: 'Journeys',
    adminUsers: 'Users',
    adminReports: 'Reports',
    adminSettings: 'Settings',
    backToLearning: 'Return to dashboard',
    openMenu: 'Open navigation',
    closeMenu: 'Close navigation',
    skipToContent: 'Skip to content',
    signInRequired: 'Sign in required',
  },

  auth: {
    loginTitle: 'Sign in',
    loginSubtitle: 'Continue your learning',
    reybexLoginSubtitle: 'Sign in with your Reybex username and password',
    lmsAccount: 'Academy Account',
    reybexAccount: 'Reybex Account',
    username: 'Username',
    signInWithReybex: 'Sign in with Reybex',
    registerTitle: 'Create your account',
    registerSubtitle: 'Start learning in a couple of minutes',
    forgotTitle: 'Reset your password',
    forgotSubtitle: 'We will email you a reset link',
    resetTitle: 'Choose a new password',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    fullName: 'Full Name',
    signIn: 'Sign in',
    signUp: 'Create account',
    sendResetLink: 'Send reset link',
    updatePassword: 'Update Password',
    noAccount: 'No account yet?',
    haveAccount: 'Already have an account?',
    forgotPassword: 'Forgot your password?',
    backToLogin: 'Back to sign in',
    landingPage: 'Landing Page',
    continueAsGuest: 'Continue without signing in',
    resetLinkSent: 'Check your inbox for the reset link.',
    passwordUpdated: 'Your password has been updated.',
    registrationComplete: 'Your account was created. Sign in to continue.',
    signedOut: 'You have been signed out.',
    accountDeactivated:
      'This account has been deactivated. Contact an administrator to restore access.',
    sessionExpired: 'Your session has expired. Please sign in again.',
    showPassword: 'Show Password',
    hidePassword: 'Hide Password',
    profile: 'Your Profile',
    profileSubtitle: 'Your details and how the platform behaves for you.',
    reybexDetails: {
      partnerAccount: 'Partner Account',
      title: 'Reybex Account Details',
      tenantId: 'Tenant ID',
      username: 'Username',
      email: 'Email',
      phone: 'Phone',
      mobile: 'Mobile',
      language: 'Language',
      timezone: 'Time Zone',
      position: 'Position',
      signInAgain: 'Sign out and sign in with your Reybex account again to load your details.',
    },
    accountDetails: 'Account Details',
    academyAccountDetails: 'Academy Account Details',
    timezone: 'Time Zone',
    changePassword: 'Change Password',
    newPassword: 'New Password',
    passwordHint: 'At least 8 characters.',
    passwordManagedByReybex: 'This account’s password is managed in Reybex.',
    memberSince: 'Member since {date}',
    profileSaved: 'Your profile has been saved.',
  },

  dashboard: {
    greeting: 'Hello, {name}',
    learnerSubtitle: 'Here is where you left off.',
    adminTitle: 'Course catalogue',
    adminSubtitle: 'Create courses, then add lessons, quizzes and publish them.',
    defineCourses: 'Your courses',
    defineCoursesHint: 'Create a course to start defining content.',
    newCourseHint: 'A title is enough. You fill in the rest in the editor.',
    noCoursesYet: 'No courses yet',
    claimAdminBanner:
      'This installation has no administrator yet. Claim the admin role to define courses.',
    claimAdminAction: 'Open admin setup',
    totalPoints: 'Total points',
    inProgress: 'In progress',
    completed: 'Completed',
    notStarted: 'Not started',
    certificates: 'Certificates',
    averageProgress: 'Average progress',
    continueLearning: 'Continue learning',
    recentCourses: 'Recently accessed',
    assignedCourses: 'Assigned to you',
    recommended: 'Recommended for you',
    journeyProgress: 'Your journeys',
    upcomingDeadlines: 'Upcoming deadlines',
    achievements: 'Achievements',
    noDeadlines: 'No deadlines coming up.',
    noAchievements: 'Complete a course to earn your first achievement.',
    achievementsInvite: 'Finish a course, collect a certificate, or complete a journey.',
    totalUsers: 'Users',
    activeLearners: 'Active learners (30 days)',
    totalCourses: 'Courses',
    completionRate: 'Completion rate',
    quizPerformance: 'Average quiz score',
    quizPassRate: 'Quiz pass rate',
    popularCourses: 'Most popular courses',
    recentRegistrations: 'Recent registrations',
    recentCompletions: 'Recent completions',
    overdueAssignments: 'Overdue assignments',
    certificatesIssued: 'Certificates issued',
    enrollments: 'Enrollments',
  },

  onboarding: {
    suggested: 'Suggested courses',
    personalize: 'Personalize',
    emptyHint: 'Choose your area to see courses picked for you.',
    welcomeTitle: 'Welcome to Reybex Campus',
    welcomeBody: 'Let’s personalize your learning experience in under a minute.',
    start: 'Start setup',
    skip: 'Skip for now',
    back: 'Back',
    next: 'Next',
    finish: 'Finish',
    stepOf: 'Question {current} of {total}',
    roleTitle: 'What best describes your work?',
    roleMulti: 'You can choose more than one.',
    levelTitle: 'What is your experience with reybex?',
    focusTitle: 'What would you like to focus on first?',
    focusOptional: 'You can skip this step.',
    doneTitle: 'You’re set',
    doneBody: 'Suggested courses now follow the areas you chose.',
    role: {
      sales: 'Sales',
      salesBody: 'Offers, customers and sales processes.',
      warehouse: 'Warehouse',
      warehouseBody: 'Stock, picking and shipping.',
      purchasing: 'Purchasing',
      purchasingBody: 'Suppliers and procurement.',
      production: 'Production',
      productionBody: 'Manufacturing and shop-floor flows.',
      finance: 'Finance',
      financeBody: 'Invoicing, payments and reporting.',
      ecommerce: 'E-commerce',
      ecommerceBody: 'Shop, orders and online sales.',
      developer: 'Technical',
      developerBody: 'Setup, APIs and extensions.',
      partner: 'Partner',
      partnerBody: 'Enablement for external partners.',
    },
    level: {
      new: 'New to reybex',
      basic: 'Basic knowledge',
      intermediate: 'Intermediate',
      advanced: 'Advanced',
    },
    focus: {
      quick: 'Quick onboarding',
      role: 'Role-based training',
      certificates: 'Certificates',
      advanced: 'Advanced processes',
    },
    none: 'No courses in this area yet.',
  },

  courses: {
    title: 'Courses',
    subtitle: 'Browse what is available and pick up where you left off.',
    myCourses: 'My courses',
    catalog: 'Catalogue',
    allCourses: 'All courses',
    enroll: 'Enroll',
    signInToEnroll: 'Sign in to enroll',
    enrolling: 'Enrolling…',
    enrolled: 'Enrolled',
    start: 'Start course',
    continue: 'Continue',
    review: 'Review',
    retakeQuiz: 'Retake quiz',
    takeQuiz: 'Take the quiz',
    viewCourse: 'View',
    lessons: '{count} lessons',
    lessonsLabel: 'Lessons',
    lessonsCompleted: '{done} of {total} lessons',
    category: 'Category',
    difficulty: 'Difficulty',
    instructor: 'Instructor',
    language: 'Language',
    objectives: 'What you will learn',
    prerequisites: 'Prerequisites',
    courseContent: 'Course content',
    aboutCourse: 'About this course',
    estimatedDuration: 'Estimated Duration',
    certificateAvailable: 'Certificate on completion',
    pointsOnCompletion: '{points} points on completion',
    quizRequired: 'A final quiz must be passed to complete this course.',
    difficultyBeginner: 'Beginner',
    difficultyIntermediate: 'Intermediate',
    difficultyAdvanced: 'Advanced',
    visibilityPrivate: 'Private',
    visibilityPublic: 'Public',
    statusDraft: 'Draft',
    statusPublished: 'Published',
    statusArchived: 'Archived',
    state: {
      not_started: 'Not started',
      in_progress: 'In progress',
      quiz_pending: 'Quiz pending',
      quiz_failed: 'Quiz failed',
      completed: 'Completed',
    },
    stateHint: {
      not_started: 'You have not started this course yet.',
      in_progress: 'Keep going — some required lessons are still open.',
      quiz_pending: 'All lessons are done. Pass the quiz to complete the course.',
      quiz_failed: 'You did not reach the passing score. Review the lessons and try again.',
      completed: 'You have completed this course.',
    },
    empty: 'No courses to show yet.',
    emptyEnrolled: 'You are not enrolled in any course yet.',
    emptyCatalog: 'Nothing has been published yet. Check back soon.',
    archivedNotice: 'This course is archived. You can review it but it can no longer be started.',
    unpublishedNotice:
      'This course is no longer published. You keep access because you were already enrolled.',
  },

  player: {
    courseContent: 'Course content',
    lesson: 'Lesson',
    quiz: 'Quiz',
    markComplete: 'Mark as complete',
    markingComplete: 'Saving…',
    completed: 'Completed',
    nextLesson: 'Next lesson',
    previousLesson: 'Previous lesson',
    resources: 'Downloads',
    transcript: 'Transcript',
    noResources: 'No downloads for this lesson.',
    progressLabel: '{percent}% complete',
    lessonCompletedToast: 'Lesson completed',
    allLessonsDone: 'All lessons are complete.',
    quizPendingBanner: 'You have finished every required lesson. The quiz is the last step.',
    quizFailedBanner: 'Your last attempt did not pass. Review the material and try again.',
    courseCompleteBanner: 'Course complete. Your points and certificate are ready.',
    courseCompleteShort: 'Course complete.',
    quizLockedByLessons: 'Complete all required lessons to unlock the quiz.',
    resumeNotice: 'Resumed where you left off.',
    videoUnavailable: 'This video cannot be played right now.',
    videoUnavailableHint:
      'The file could not be loaded. You can try again, or continue with another lesson.',
    videoMissingSource: 'No video file has been attached to this lesson yet.',
    reportProblem: 'Report a problem',
    problemReported: 'Thanks — an administrator has been notified.',
    offline: 'You are offline. Your progress will be saved when the connection returns.',
    backToCourse: 'Course overview',
    requiredLesson: 'Required',
    optionalLesson: 'Optional',
    journeyContext: 'Part of {journey}',
    nextInJourney: 'Next in this journey',
    exitPlayer: 'Exit player',
    lessonList: 'Lessons',
    pauseNudge: 'Keep going — {percent}% left to complete this lesson.',
    watchRing: '{watched}% watched. Completes at {threshold}%.',
    requirementsChanged: 'This course was updated and now has additional required lessons.',
  },

  quiz: {
    title: 'Quiz',
    start: 'Start quiz',
    starting: 'Starting…',
    resume: 'Resume quiz',
    submit: 'Submit answers',
    submitting: 'Submitting…',
    question: 'Question {current} of {total}',
    passingScore: 'Passing score: {score}%',
    timeLimit: 'Time limit: {minutes} min',
    noTimeLimit: 'No time limit',
    attemptsLeft: '{count} attempts left',
    attemptsUnlimited: 'Unlimited attempts',
    attemptNumber: 'Attempt {number}',
    timeRemaining: 'Time remaining',
    timeUp: 'Time is up. Your answers have been submitted.',
    selectOne: 'Select one answer',
    selectMultiple: 'Select all that apply',
    trueLabel: 'True',
    falseLabel: 'False',
    unanswered: '{count} unanswered',
    confirmSubmitTitle: 'Submit your answers?',
    confirmSubmitBody:
      'You have {count} unanswered questions. Submitting now scores them as incorrect.',
    confirmSubmitAll: 'Submit anyway',
    resultPassed: 'You passed',
    resultFailed: 'Not passed',
    certificateUnlocked: 'You earned the course certificate.',
    redirectingToCertificate: 'Taking you to your certificate…',
    yourScore: 'Your score',
    scoreOf: '{score}% (passing score {passing}%)',
    reviewAnswers: 'Review your answers',
    continueToFeedback: 'Continue to course feedback',
    backToResults: 'Back to quiz results',
    reviewLoadError:
      'Your result is saved, but your answer review could not be loaded. Please try again.',
    correct: 'Correct',
    incorrect: 'Incorrect',
    explanation: 'Explanation',
    attemptHistory: 'Previous attempts',
    noAttempts: 'No attempts yet.',
    maxAttemptsReached:
      'You have used all {count} attempts. Ask an administrator if you need another try.',
    retake: 'Try again',
    backToCourse: 'Back to the course',
    expiredNotice: 'This attempt was submitted after the time limit and has been scored as is.',
    invalidatedNotice:
      'The quiz changed while your attempt was open, so it was discarded. You can start again at no cost.',
    draftRestored: 'Restored the answers you had already chosen.',
    submitFailedRetrying: 'Submission failed. Retrying…',
    submitFailed: 'We could not submit your answers. Check your connection and try again.',
  },

  journeys: {
    title: 'Journeys',
    subtitle: 'Structured paths that combine several courses.',
    start: 'Start journey',
    signUpToStart: 'Create an account to start',
    continue: 'Continue journey',
    leave: 'Leave journey',
    leaveConfirmTitle: 'Leave this journey?',
    leaveConfirmBody:
      'Your course progress is kept. You can rejoin later and continue where you stopped.',
    rejoin: 'Rejoin journey',
    courses: 'Courses in this journey',
    courseCount: '{count} courses',
    modeSequential: 'Sequential',
    modeFlexible: 'Flexible',
    modeSequentialHint: 'Required courses must be completed in order.',
    modeFlexibleHint: 'Required courses can be completed in any order.',
    locked: 'Locked',
    lockedHint: 'Complete the previous required course to unlock this one.',
    completedCourses: 'Completed',
    remainingCourses: 'Remaining',
    state: {
      not_started: 'Not started',
      in_progress: 'In progress',
      completed: 'Completed',
      abandoned: 'Left',
    },
    empty: 'No journeys have been published yet.',
    completedBanner: 'Journey complete. Your certificate is ready.',
    objectives: 'What this journey covers',
  },

  certificates: {
    title: 'Certificates',
    subtitle: 'Everything you have earned.',
    certificateNumber: 'Certificate number',
    issuedOn: 'Issued on',
    expiresOn: 'Expires on',
    noExpiry: 'No expiry',
    learner: 'Awarded to',
    course: 'Course',
    journey: 'Journey',
    downloadPdf: 'Download PDF',
    generating: 'Preparing…',
    verify: 'Verify',
    verifyTitle: 'Certificate verification',
    verifySubtitle: 'Check whether a certificate is genuine.',
    verifyLinkCopied: 'Verification link copied.',
    copyVerifyLink: 'Copy verification link',
    empty: 'You have no certificates yet. Complete a course to earn one.',
    justEarned: 'Congratulations — your certificate is ready.',
    statusActive: 'Valid',
    statusRevoked: 'Revoked',
    statusExpired: 'Expired',
    notFound: 'No certificate matches this verification link.',
    verifiedValid: 'This certificate is valid.',
    verifiedRevoked: 'This certificate was revoked on {date}.',
    verifiedExpired: 'This certificate expired on {date}.',
    issuedBy: 'Issued by',
    revoke: 'Revoke',
    revokeTitle: 'Revoke this certificate?',
    revokeBody:
      'The certificate stops verifying immediately. Points already earned are not removed.',
    revokeReason: 'Reason',
    revoked: 'Certificate revoked.',
    certificateOfCompletion: 'Certificate of Completion',
    hasCompleted: 'has successfully completed',
    certificateEyebrow: 'Certificate',
    certifiesThat: 'This is to certify that',
    hasCompletedProgram: 'has successfully completed the training',
    validUntil: 'Valid until {date}',
    verifyAt: 'Verify this certificate at',
    preview: 'Preview certificate',
  },

  admin: {
    coursesTitle: 'Courses',
    coursesSubtitle: 'Create and manage course content.',
    newCourse: 'New course',
    editCourse: 'Edit course',
    courseCreated: 'Course created.',
    courseUpdated: 'Course saved.',
    courseDeleted: 'Course deleted.',
    coursePublished: 'Course published.',
    courseUnpublished: 'Course moved back to draft.',
    courseArchived: 'Course archived.',
    deleteCourseTitle: 'Delete this course?',
    deleteCourseBody: 'This cannot be undone. Archive it instead if learners have used it.',
    tabDetails: 'Details',
    tabContent: 'Content',
    tabQuiz: 'Quiz',
    tabCompletion: 'Completion',
    tabPublish: 'Publish',
    slug: 'URL Slug',
    slugHint: 'Used in the course address. Generated from the title.',
    shortDescription: 'Short Description',
    shortDescriptionHint: 'One line shown on course cards.',
    documentEditorHint:
      'Write the course as a document: headings, lists, images, YouTube and HTTPS iframes. Content is sanitised before learners see it.',
    documentEditorPlaceholder: 'Describe the course, add examples, embed a walkthrough…',
    insertLink: 'Link',
    insertImage: 'Image',
    insertYoutube: 'YouTube',
    insertIframe: 'Iframe',
    insertImagePrompt: 'Image URL (https://)',
    insertYoutubePrompt: 'YouTube URL',
    insertIframePrompt: 'Embed URL (https:// iframe src)',
    thumbnail: 'Cover Image',
    thumbnailHint: 'Shown on course and journey cards. Choose one of the Academy covers.',
    thumbnailLibrary: 'Choose a cover image',
    chooseThumbnail: 'Choose cover',
    clearThumbnail: 'Remove cover',
    durationFromLessons: 'Calculated from the minutes of the lessons in this course.',
    durationFromCourses: 'Calculated from the durations of the courses in this learning path.',
    courseIllustration: 'Course illustration',
    courseIllustrationHint: 'This is the visual identity of the course in the catalog.',
    courseIllustrationLibrary: 'Choose a course visual',
    chooseIllustration: 'Choose visual',
    illustrationCovers: 'Covers',
    illustrationModules: 'Product images',
    illustrationDrawings: 'Illustrations',
    illustrationPhotos: 'Photos',
    illustrations: {
      moduleAdministration: 'Administration',
      moduleAllgemein: 'General',
      moduleArtikelPim: 'Articles / PIM',
      moduleCrm: 'CRM',
      moduleCrmPhoto: 'CRM',
      moduleEcommerce: 'E-Commerce',
      moduleEinkauf: 'Purchasing',
      moduleEntwicklung: 'Development',
      moduleFinanzen: 'Finance',
      moduleKassePos: 'POS',
      moduleMobileLager: 'Mobile Warehouse App',
      moduleVerkauf: 'Sales',
      moduleVersand: 'Shipping',
      erp: 'ERP / Enterprise',
      cloud: 'Cloud ERP',
      dashboard: 'Business Dashboard',
      sales: 'Sales Management',
      purchasing: 'Procurement',
      warehouse: 'Warehouse',
      inventory: 'Inventory',
      products: 'Products',
      crm: 'CRM',
      production: 'Production',
      supplyChain: 'Supply Chain',
      finance: 'Finance',
      invoice: 'Invoice',
      documents: 'Documents',
      workflow: 'Workflow',
      automation: 'Automation',
      ai: 'AI Assistant',
      integration: 'Integration',
      users: 'Users & Roles',
      analytics: 'Analytics',
      photoOperations: 'Business operations',
      photoCloud: 'Data center',
      photoWarehouse: 'Warehouse floor',
      photoFulfillment: 'Order fulfillment',
      photoFinance: 'Financial data',
      photoLogistics: 'Logistics',
      photoTeam: 'Team',
      photoAnalytics: 'Analytics screen',
      photoServers: 'Servers',
      photoFactory: 'Manufacturing',
    },
    cover: 'Cover image',
    tags: 'Tags',
    tagsHint: 'Press Enter to add a tag.',
    objectives: 'Learning Objectives',
    prerequisites: 'Prerequisites',
    estimatedDuration: 'Estimated Duration (Minutes)',
    visibility: 'Visibility',
    visibilityHint:
      'Public and published, with no groups: anyone with the link can view (no quiz or progress). Groups still restrict who may enrol. If groups are selected, public and published content appears only in the catalogs of users belonging to at least one selected group.',
    groups: 'Groups',
    courseGroupsLabel: 'Groups (Who can enroll)',
    courseGroupsHint:
      'Selecting any groups limits viewing and self-enrollment to users in at least one selected group, including private courses shared by link. With no groups: public courses allow self-enrollment; private courses require an assignment. Adding someone to Assigned Learners enrolls them regardless of group membership.',
    groupsHint:
      'Leave empty on a public item so the link is open. Empty on a private item means staff and assignments only. Selecting groups limits access to those learner types.',
    publicLinkHint: 'Share this view-only link. Quizzes and progress still require sign-in.',
    guestPreview: 'You are viewing a preview. Sign in to take quizzes and save progress.',
    guestPreviewAuthed: 'You are viewing a preview. Enroll to take quizzes and save your progress.',
    guestQuizLocked: 'Quizzes require an account. Sign in to start this quiz.',
    guestQuizEnroll: 'Enroll to take this quiz and save your progress.',
    openAsLearner: 'Open in my account',
    sections: 'Sections',
    addSection: 'Add section',
    sectionTitle: 'Section title',
    noSections: 'No sections yet. Add one to start building the course.',
    addLesson: 'Add lesson',
    lessonType: 'Lesson Type',
    lessonTypeVideo: 'Video',
    lessonTypeText: 'Text',
    lessonTypeQuiz: 'Quiz',
    noLessons: 'No lessons in this section yet.',
    lessonRequired: 'Required for Completion',
    lessonSaved: 'Lesson saved.',
    lessonDeleted: 'Lesson deleted.',
    lessonArchived: 'Lesson archived.',
    lessonArchivedHint:
      'Learners have progress on this lesson, so it was archived instead of deleted. It no longer counts towards completion.',
    deleteLessonTitle: 'Delete this lesson?',
    deleteLessonBody: 'Learner progress for this lesson will be kept but it will be hidden.',
    deleteSectionBody: 'Lessons in this section become ungrouped. They are not deleted.',
    ungroupedLessons: 'Ungrouped lessons',
    questionTypeSingle: 'Single choice',
    questionTypeMultiple: 'Multiple choice',
    questionTypeTrueFalse: 'True / False',
    settingsSaved: 'Settings saved.',
    defaultPoints: 'Default Points for a New Course',
    assignTitle: 'Assign to learners',
    assignSubtitle:
      'Selected learners are enrolled immediately and see the due date on their dashboard.',
    tabAssignments: 'Assignments',
    designTitle: 'UI primitives',
    reorderSaved: 'Order saved.',
    moveUp: 'Move up',
    moveDown: 'Move down',
    dragLesson: 'Drag to move',
    dragJourneyCourse: 'Drag to reorder',
    dropLessonHere: 'Drop a lesson here',
    videoMetadata: 'Video',
    videoTitle: 'Video Title',
    videoUrl: 'External Video URL',
    videoUrlHint:
      'Paste a YouTube, Guidde or other HTTPS embed link, or a direct video file. Nothing is uploaded here.',
    videoPath: 'External File Path',
    videoDuration: 'Duration (Seconds)',
    videoThumbnail: 'Thumbnail URL',
    videoTranscript: 'Transcript',
    videoTranscriptHint:
      'Optional. Upload a .txt, .vtt or .srt file. Learners see it under the video.',
    uploadTranscript: 'Upload transcript',
    transcriptWrite: 'or type it here',
    transcriptPlaceholder: 'Paste or type the transcript',
    replaceTranscript: 'Replace transcript',
    transcriptAttached: 'Current transcript ({count} characters)',
    transcriptEmpty: 'That file has no text.',
    videoStatus: 'Video status',
    uploadVideo: 'Upload video',
    uploadVideoHint:
      'Upload to the external file server is not connected yet. Selecting a file records its details and logs the request.',
    selectedFile: 'Selected file',
    uploadRequested: 'Upload requested. The request was logged for the file server integration.',
    textContent: 'Lesson Content',
    textContentHint: 'Basic formatting is supported. Content is sanitised before it is shown.',
    resources: 'Downloads',
    addResource: 'Add download',
    completionTitle: 'Completion requirements',
    completionSubtitle: 'What a learner must do before the course counts as complete.',
    requiredLessons: 'Required lessons',
    requiredLessonsCount: '{count} of {total} lessons are required',
    requiresQuiz: 'Require a Passing Quiz',
    requiresQuizHint: 'When off, completing the required lessons completes the course.',
    finalQuiz: 'Final quiz',
    passingScore: 'Passing Score (%)',
    coursePoints: 'Points Awarded',
    certificateEnabled: 'Issue a Certificate',
    videoCompletePercent: 'Video Counts as Watched at (%)',
    publishTitle: 'Publish',
    publishSubtitle: 'Checks that must pass before learners can see this course.',
    publishCheckLessons: 'At least one required lesson',
    publishCheckQuiz: 'A final quiz with at least one question',
    publishCheckDescription: 'A short description',
    publishBlocked: 'Resolve the items above before publishing.',
    quizBuilderTitle: 'Quiz',
    quizBuilderSubtitle: 'Learners see this as the last item in the course.',
    createQuiz: 'Create quiz',
    quizTitle: 'Quiz Title',
    timeLimitMinutes: 'Time Limit (Minutes)',
    timeLimitHint: 'Leave empty for no limit.',
    maxAttempts: 'Maximum Attempts',
    maxAttemptsHint: 'Leave empty for unlimited attempts.',
    shuffleQuestions: 'Shuffle Questions',
    addQuestion: 'Add question',
    importQuestions: 'Import questions',
    importPoints: 'Points per question',
    importPointsInvalid: 'Enter a whole number from 1 to 100.',
    importQuestionsHint:
      'Paste single-choice questions. Use AIKEN (A. B. C. then ANSWER: B), or put each option on its own line and mark the correct one with ✓. Leave a blank line between questions.',
    importQuestionsPlaceholder: 'Paste questions in AIKEN or ✓ format',
    importQuestionsAction: 'Import',
    importQuestionsSuccess: '{count} questions imported.',
    importQuestionsEmpty: 'Paste at least one question.',
    importQuestionsError: 'Question {question}: {reason}',
    aikenUnrecognized: 'This block is not AIKEN or checkmark format.',
    aikenNoAnswer: 'Add ANSWER: X, or mark exactly one option with ✓.',
    aikenAnswerMismatch: 'ANSWER {answer} does not match an option.',
    aikenTooFewOptions: 'At least two options are required.',
    aikenMultipleCorrect: 'Only one correct answer is allowed.',
    aikenDuplicateLetter: 'The letter {letter} is used more than once.',
    aikenNoPrompt: 'The question text is missing.',
    aikenAmbiguous: 'Use either ANSWER: X or a ✓ mark, not both.',
    aikenTooLong: 'The question or an option is too long.',
    questionPrompt: 'Question',
    questionType: 'Type',
    questionPoints: 'Points',
    questionExplanation: 'Explanation Shown after Submission',
    addOption: 'Add option',
    optionLabel: 'True answer',
    markCorrect: 'Correct',
    noQuestions: 'No questions yet.',
    quizSaved: 'Quiz saved.',
    quizNeedsCorrectOption: 'Every question needs at least one correct answer.',
    quizEditWarning:
      'This quiz has been attempted. Structural changes discard attempts that are still open; submitted attempts keep their score.',
    journeysTitle: 'Journeys',
    journeysSubtitle: 'Combine courses into a structured path.',
    newJourney: 'New journey',
    editJourney: 'Edit journey',
    journeySaved: 'Journey saved.',
    journeyMode: 'Completion Order',
    journeyCourses: 'Courses',
    filterByJourney: 'Journey',
    allJourneys: 'All journeys',
    filterContainsCourse: 'Contains course',
    allCourses: 'All courses',
    backToJourney: 'Back to journey',
    backToCourses: 'Back to courses',
    addCourseToJourney: 'Add course',
    addExistingCourse: 'Existing course',
    addExistingCourseHint: 'Pick a course that is already in the catalogue.',
    createCourseForJourney: 'New course',
    createCourseForJourneyHint:
      'Creates a draft with a title. It is added to this journey immediately; you add lessons in the course editor.',
    createAndAddToJourney: 'Create and add',
    noCatalogCoursesLeft: 'Every available course is already on this journey.',
    courseAddedToJourney: 'Course added to the journey.',
    courseRequired: 'Required',
    courseOptional: 'Optional',
    noJourneyCourses: 'No courses added yet.',
    settingsTitle: 'Settings',
    settingsSubtitle: 'Defaults applied to new content.',
    defaultsSection: 'Content defaults',
    maintenanceSection: 'Maintenance',
    recalcStates: 'Rebuild course states',
    recalcStatesHint:
      'Recomputes every enrollment from lesson progress and quiz attempts. Safe to run at any time.',
    recalcDone: 'Rebuilt {count} enrollments.',
    brandingSection: 'Branding',
    organisationName: 'Organisation Name',
    defaultLocale: 'Default Language',
  },

  users: {
    title: 'Users',
    subtitle: 'Manage who can access the platform and what they can do.',
    invite: 'Invite user',
    inviteTitle: 'Invite a user',
    inviteSubtitle: 'They receive an email with a link to set their password.',
    inviteSent: 'Invitation sent to {email}.',
    inviteFailed: 'The invitation could not be sent.',
    pendingInvitations: 'Pending invitations',
    revokeInvitation: 'Revoke',
    invitationRevoked: 'Invitation revoked.',
    role: 'Role',
    roleName: {
      learner: 'Learner',
      instructor: 'Instructor',
      admin: 'Admin',
    },
    roleChanged: 'Role updated. The user sees the change after their next sign-in.',
    active: 'Active',
    inactive: 'Deactivated',
    activate: 'Activate',
    deactivate: 'Deactivate',
    activated: 'User activated.',
    deactivated: 'User deactivated.',
    joined: 'Joined',
    lastActive: 'Last active',
    viewProgress: 'View progress',
    progressTitle: 'Progress for {name}',
    assignCourse: 'Assign course',
    assignedLearners: 'Assigned Learners',
    assignmentsSaved: 'Assignments saved.',
    assignJourney: 'Assign journey',
    assigned: 'Assigned to {count} learners.',
    unassign: 'Remove assignment',
    unassigned: 'Assignment removed.',
    dueDate: 'Due Date',
    selectLearners: 'Learners',
    noLearnersSelected: 'Select at least one learner.',
    empty: 'No users match your filters.',
    cannotChangeOwnRole: 'You cannot change your own role.',
    cannotDeactivateSelf: 'You cannot deactivate your own account.',
    groups: 'Groups',
    groupsUpdated: 'Groups updated.',
  },

  groups: {
    label: 'Groups',
    partner: 'Partner',
    developer: 'Developer',
    viewer: 'Viewer',
  },

  reports: {
    title: 'Reports',
    subtitle: 'Enrollment, completion and quiz performance.',
    tabCourses: 'Courses',
    tabLearners: 'Learners',
    tabQuizzes: 'Quizzes',
    tabJourneys: 'Journeys',
    course: 'Course',
    enrollments: 'Enrollments',
    completed: 'Completed',
    inProgress: 'In progress',
    notStarted: 'Not started',
    completionRate: 'Completion rate',
    averageProgress: 'Average progress',
    quiz: 'Quiz',
    attempts: 'Attempts',
    learners: 'Learners',
    passRate: 'Pass rate',
    averageScore: 'Average score',
    passingScore: 'Passing score',
    learnerName: 'Learner',
    coursesCompleted: 'Courses completed',
    points: 'Points',
    certificates: 'Certificates',
    exportCsv: 'Export CSV',
    empty: 'No data for this report yet.',
  },

  states: {
    loading: 'Loading',
    loadingHint: 'One moment…',
    errorTitle: 'Something went wrong',
    errorHint: 'The request did not complete. You can try again.',
    emptyTitle: 'Nothing here yet',
    notFoundTitle: 'Page not found',
    notFoundHint: 'The page you are looking for does not exist or has moved.',
    forbiddenTitle: 'No access',
    forbiddenHint: 'You do not have permission to view this page.',
    goHome: 'Go to dashboard',
    offlineTitle: 'You are offline',
    offlineHint: 'Check your connection. Your work is kept locally until it returns.',
  },

  errors: {
    generic: 'Something went wrong. Please try again.',
    network: 'We could not reach the server. Check your connection.',
    unauthorized: 'You need to sign in to do that.',
    forbidden: 'You do not have permission to do that.',
    notFound: 'We could not find what you were looking for.',
    conflict: 'That already exists.',
    invalidCredentials: 'That email and password combination is not correct.',
    invalidReybexCredentials: 'That Reybex username and password combination is not correct.',
    reybexEmailInUse:
      'An LMS account already uses this email. Sign in with the LMS account option.',
    reybexNotConfigured: 'Reybex sign-in is not configured.',
    reybexUnavailable: 'Reybex could not be reached. Try again in a moment.',
    reybexTenantNotAllowed: 'This Reybex account is not allowed to sign in here.',
    passwordManagedByReybex: 'This password is managed in Reybex.',
    emailInUse: 'An account with that email already exists.',
    weakPassword: 'Pick a longer password.',
    rateLimited: 'Too many attempts. Please wait a moment and try again.',
    slugTaken: 'That URL slug is already used by another course.',
    notEnrolled: 'You are not enrolled in this course.',
    lessonsIncomplete: 'Complete the required lessons first.',
    maxAttempts: 'You have used all your attempts for this quiz.',
    quizNoQuestions: 'This quiz has no questions yet.',
    attemptClosed: 'This attempt has already been submitted.',
    selfEnrollClosed: 'This course is not open for self-enrollment.',
    lessonHasProgress:
      'Learners have progress on this lesson, so it can only be archived, not deleted.',
    schemaMissing:
      'The database schema is not applied yet. In the project folder run: npm run db:migrate',
  },

  validation: {
    required: 'This field is required',
    email: 'Enter a valid email address',
    minLength: 'Use at least {min} characters',
    maxLength: 'Use at most {max} characters',
    passwordMin: 'Use at least 8 characters',
    passwordMatch: 'The passwords do not match',
    passwordNeeds: 'Still needed: {items}.',
    passwordNeed: {
      length: 'At least 9 characters',
      upper: 'Add an uppercase letter',
      lower: 'Add a lowercase letter',
      digit: 'Add a number',
      special: 'Add a special character',
    },
    number: 'Enter a number',
    min: 'Must be at least {min}',
    max: 'Must be at most {max}',
    url: 'Enter a valid URL',
    slug: 'Use lowercase letters, numbers and hyphens only',
    fileTooLarge: 'That file is larger than the {max} limit',
    fileType: 'That file type is not supported',
    atLeastOne: 'Select at least one',
    atLeastOneCorrect: 'Mark at least one option as correct',
    atLeastTwoOptions: 'Add at least two answer options',
    positiveInteger: 'Enter a whole number greater than zero',
  },

  rewards: {
    continue: 'Continue',
    kindLesson: 'Lesson complete',
    kindQuiz: 'Quiz passed',
    kindCourse: 'Course complete',
    kindCertificate: 'Certificate earned',
    kindJourney: 'Journey complete',
    lessonTitle: 'Nice work',
    lessonBody: 'You finished “{title}”.',
    quizTitle: 'You passed',
    quizBody: 'That score unlocks the next step.',
    quizBodyCertificate: 'Score at or above the passing mark — your certificate is ready.',
    quizRetryHint: 'No celebration yet — review the lesson and try again.',
    courseTitle: 'Course complete',
    courseBody: 'You finished {title}.',
    certificateTitle: 'Certificate unlocked',
    certificateBody: 'You earned a certificate for {title}.',
    viewCertificate: 'View certificate',
    journeyTitle: 'Journey complete',
    journeyBody: 'You finished the path “{title}”.',
    score: 'Score: {score}',
  },

  setup: {
    title: 'Administrator setup',
    subtitle: 'The first administrator can define courses for the organisation.',
    body: 'Nobody is an administrator yet. Claiming this role lets you create and publish courses. Later signups stay learners unless you invite them.',
    claim: 'Become administrator',
    claimed: 'You are now the administrator.',
    alreadyAdmin: 'You already have staff access. Open the admin dashboard to define courses.',
    unavailable: 'An administrator already exists. Ask them to invite you if you need access.',
  },

  landing: {
    metaTitle: 'Reybex Academy',
    product: 'Academy',
    navJourneys: 'Journeys',
    navHow: 'How it works',
    navCerts: 'Certificates',
    navAudience: 'Who it is for',
    themeToLight: 'Switch to light mode',
    themeToDark: 'Switch to dark mode',
    signIn: 'Sign in',
    signUp: 'Create account',
    openCampus: 'Open Campus',
    eyebrow: 'Learning platform for reybex Cloud ERP',
    headlineLead: 'Master the ERP',
    headlineAccent: 'that runs the business.',
    sub: 'Structured journeys for partners, developers and operators — from warehouse to finance. Finish the lessons, pass the quiz, earn a certificate anyone can verify.',
    ctaStart: 'Start learning',
    ctaExplore: 'Explore journeys',
    statLevels: 'Learning levels',
    statLevelsValue: 'L0–L4',
    statAudiences: 'Audiences',
    statAudiencesValue: '3 roles',
    statLangs: 'Languages',
    statLangsValue: 'DE · EN',
    statProof: 'Proof',
    statProofValue: 'Certificates',
    audiencesTitle: 'Built for the people who run reybex',
    audiencesSub:
      'Partner, Developer and Viewer each get a path that matches how they actually use the cloud ERP — not a generic catalogue.',
    audiencePartnerTitle: 'Partner',
    audiencePartnerBody:
      'Enablement for implementation partners: processes, configuration, and how to train the customer team.',
    audienceDeveloperTitle: 'Developer',
    audienceDeveloperBody:
      'Configuration depth, APIs and the technical path from setup to extension — without mixing it with end-user training.',
    audienceViewerTitle: 'Viewer',
    audienceViewerBody:
      'Day-to-day work in sales, warehouse, purchasing and finance. Only what the role needs to move.',
    levelsEyebrow: 'Curriculum',
    levelsTitle: 'A path from first login to certification',
    levelsSub:
      'Five levels, the same language as the reybex organisation. Each course can require a quiz before it counts as complete.',
    level0: 'Basics',
    level0Body: 'Orientation in the cloud ERP. Navigation, master data, the common core.',
    level1: 'Department',
    level1Body: 'Sales, warehouse, purchasing, finance — the work of a specialist.',
    level2: 'Configuration',
    level2Body: 'How the system is set up for a real company.',
    level3: 'Developer',
    level3Body: 'Integrations, API-first thinking, and extending reybex.',
    level4: 'Practice & certification',
    level4Body: 'Apply it, pass the exam, take the certificate.',
    howTitle: 'Quiz-gated. Then certified.',
    howSub:
      'A course is complete only when required lessons are done and the exam is passed. Points and certificates follow automatically — never by a manual toggle.',
    how1Title: 'Choose a journey',
    how1Body:
      'Sequential paths unlock the next course when you finish. Flexible paths let you pick the order.',
    how2Title: 'Learn in the player',
    how2Body: 'Video and text lessons. Progress is saved. Required items must be completed.',
    how3Title: 'Pass the exam',
    how3Body:
      'Scored on the server. Time limits and attempt caps are enforced. Correct answers stay hidden until you submit.',
    how4Title: 'Earn the certificate',
    how4Body: 'A unique number, a public verification link, and a PDF you can share.',
    journeysTitle: 'Learning journeys',
    journeysSub:
      'Role-based paths through the reybex modules — sales, warehouse, production, finance and more.',
    journeysCta: 'See all journeys',
    featuresTitle: 'Everything an academy needs. Nothing it does not.',
    featureJourneysTitle: 'Journeys',
    featureJourneysBody:
      'Sequential or flexible. Required courses. Progress that is always recomputed from facts.',
    featureQuizTitle: 'Honest exams',
    featureQuizBody: 'Server-side scoring. No correct answers leak into the player.',
    featureCertsTitle: 'Verifiable certificates',
    featureCertsBody:
      'Anyone can open the public verify page. Authority lives in the record, not the PDF.',
    featureGroupsTitle: 'Partner · Developer · Viewer',
    featureGroupsBody: 'Content is scoped to the group that should see it.',
    featureReportsTitle: 'Reports for admins',
    featureReportsBody: 'Completions, quiz pass rate, overdue assignments — in one view.',
    featureI18nTitle: 'German, English',
    featureI18nBody: 'The academy speaks the languages of the reybex market.',
    ctaTitle: 'Ready for the next module?',
    ctaBody: 'Create an account or sign in. Your path, your quiz, your certificate.',
    footerTagline: 'The learning campus for reybex Cloud ERP.',
    footerCourses: 'Courses',
    footerJourneys: 'Journeys',
    footerVerify: 'Certificates',
    footerRights: '© {year} EDIT Systems GmbH. Reybex Academy.',
    orbitSales: 'Sales',
    orbitWarehouse: 'Warehouse',
    orbitProduction: 'Production',
    orbitFinance: 'Finance',
    orbitCrm: 'CRM',
    orbitShop: 'Commerce',
    menuOpen: 'Open menu',
    menuClose: 'Close menu',
    mockChrome: 'Reybex Academy · Course player',
    mockPath: 'This course',
    mockLesson1: 'Navigate the workspace',
    mockLesson2: 'Master data that must stay clean',
    mockLesson3: 'A sales order, end to end',
    mockQuiz: 'Final exam',
    mockNow: 'A sales order, end to end',
    mockNowMeta: 'Video · required · 12 min',
    mockRequired: 'Required',
    mockCertEyebrow: 'Certificate',
    mockCertBody: 'Issued after the quiz is passed. Publicly verifiable.',
  },

  categories: {
    'track-administration': 'Administration',
    'track-artikel-pim': 'Articles & PIM',
    'track-crm': 'CRM',
    'track-allgemein': 'General',
    'track-continuous': 'Continuous',
    'track-e-commerce': 'E-Commerce',
    'track-edi': 'EDI',
    'track-einkauf': 'Purchasing',
    'track-entwicklung': 'Development',
    'track-finanzen': 'Finance',
    'track-hr': 'HR',
    'track-kasse-pos': 'Checkout / POS',
    'track-lager': 'Warehouse',
    'track-mobile-lager-app': 'Mobile Warehouse App',
    'track-partner-enablement': 'Partner Enablement',
    'track-praxis': 'Practice',
    'track-produktion': 'Production',
    'track-projekte-service': 'Projects & Service',
    'track-qualit-t': 'Quality',
    'track-verkauf': 'Sales',
    'track-versand': 'Shipping',
    'track-zertifizierung': 'Certification',
    'ornek-depo-lojistik': 'Warehouse and logistics',
    'ornek-satis-faturalama': 'Sales and invoicing',
  },
}
